<template>
    <div>
        <div class="h-100 w-100 full-height" @mouseover="hovered = true" @mouseleave="hovered = false">
            <b-carousel ref="myCarousel" style="text-shadow: 0px 0px 2px #000" fade indicators :interval="caroInterval"
                v-model="homeSlide">
                <div class="carousel-item active full-height fullscreen-bg">
                    <video class="fullscreen-bg__video" ref="video" autoplay muted @ended="myHandler()">
                        <source :src="'./video/MalahiniKudaBandos.mp4'" type="video/mp4" />
                        <source :src="'./video/MalahiniKudaBandos.ogv'" type="video/ogg" />
                    </video>
                    <!-- <iframe class="embed-responsive-item" style="height: 100vh; width: 100vw" :src="require('@/assets/video/MalahiniKudaBandos.mp4') + '?autoplay=1&controls=0'" allowfullscreen></iframe> -->
                </div>
                <!-- <b-carousel-slide
                caption="First slide"
                class="full-height"
                >
                
                </b-carousel-slide> -->
                <b-carousel-slide :img-src="require('@/assets/images/landing_slider_private_offers.jpeg')"
                    class="full-height">
                    <p class="white-text">Book direct and unlock amazing discounts on our private offers</p>
                    <div class="text-center mt-4">
                        <a href="#/page/specialoffers/tile0" class="home-room-details px-3">
                            <span>

                                &nbsp;&nbsp;Details&nbsp;&nbsp;
                            </span>
                        </a>
                    </div>
                </b-carousel-slide>
                <b-carousel-slide :img-src="require('@/assets/images2/landingSlides/slide2.jpg')"
                    class="full-height"></b-carousel-slide>
            </b-carousel>

            <div class="pl-5 pb-2 caro-indicators d-flex flex-row" style="width: 100vw">
                <ul class="list-inline d-none d-sm-block">
                    <li class="list-inline-item" :class="homeSlide == 0 ? 'active' : ''"><button type="button"
                            class="btn btn-link white-text font-weight-bold" style="height: 15px"
                            @click="homeSlide = 0">&nbsp;</button></li>
                    <li class="list-inline-item" :class="homeSlide == 1 ? 'active' : ''"><button type="button"
                            class="btn btn-link white-text font-weight-bold" style="height: 15px"
                            @click="homeSlide = 1">&nbsp;</button></li>
                    <li class="list-inline-item" :class="homeSlide == 2 ? 'active' : ''"><button type="button"
                            class="btn btn-link white-text font-weight-bold" style="height: 15px"
                            @click="homeSlide = 2">&nbsp;</button></li>
                </ul>
                <h3 class="text-center white-text" style="width: 85%"> މަލަހިނީ ކުޑަ ބަނޑޮސް </h3>
                <transition name="fade">
                    <h3 v-show="hovered" class="text-right mb-0" style="margin-top: -15px;"><a
                            href='https://wa.me/9607301819' target='_blank'><i style="color: #25d366; font-size: 50px;"
                                class="fab fa-whatsapp"></i></a></h3>
                </transition>
                <!-- <div class="text-center" style="width: 100vw; position: absolute; bottom: 0; z-index: 10;"> <h3 class="white-text"> މަލަހިނީ ކުޑަ ބަނޑޮސް </h3></div>  -->
            </div>
        </div>
        <div data-aos="fade-up" data-aos-offset="200" data-aos-delay="10" data-aos-duration="1000"
            data-aos-anchor-placement="top-bottom">
            <div class="row mt-4" id="roomList">
                <!-- Single Rooms Area -->
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="single-rooms-area mb-0 wow fadeInUp" data-wow-delay="100ms">
                        <!-- Thumbnail -->
                        <div class="bg-thumbnail bg-img"
                            :style="{ backgroundImage: 'url(https://www.malahini.mv:9443/web/api/picture/196)' }"></div>
                        <div class="p-2 home-room-text">
                            <div class="row">
                                <div class="col-8">
                                    <h3 class="mb-0 lemon" style="color: white;">The Villa</h3>
                                </div>
                                <div class="col-4 pt-1">
                                    <!-- <p></p> -->
                                    <a href="#/page/rooms/tile0" class="home-room-details float-right">
                                        <span>

                                            &nbsp;&nbsp;Details&nbsp;&nbsp;
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Single Rooms Area -->
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="single-rooms-area mb-0 wow fadeInUp" data-wow-delay="300ms">
                        <!-- Thumbnail -->
                        <div class="bg-thumbnail bg-img"
                            :style="{ backgroundImage: 'url(' + require('@/assets/images2/whybookdirect.jpg') + ')' }">
                        </div>
                        <div class="p-2 home-room-text">
                            <div class="row">
                                <div class="col-8">
                                    <h3 class="mb-0 lemon" style="color: white;">Why Book Direct?</h3>
                                </div>
                                <div class="col-4 pt-1">
                                    <!-- <p></p> -->
                                    <a href="#/page/specialoffers/tile0" class="home-room-details float-right">
                                        <span>

                                            &nbsp;&nbsp;Details&nbsp;&nbsp;
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Single Rooms Area -->
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="single-rooms-area mb-0 wow fadeInUp" data-wow-delay="500ms">
                        <!-- Thumbnail -->
                        <div class="bg-thumbnail bg-img"
                            :style="{ backgroundImage: 'url(' + require('@/assets/images2/SO-image.jpg') + ')' }"></div>
                        <div class="p-2 home-room-text">
                            <div class="row">
                                <div class="col-8">
                                    <h3 class="mb-0 lemon" style="color: white;">Special Offers</h3>
                                </div>
                                <div class="col-4 pt-1">
                                    <!-- <p></p> -->
                                    <a href="#/page/specialoffers" class="home-room-details float-right">
                                        <span>

                                            &nbsp;&nbsp;Details&nbsp;&nbsp;
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ##### Malahini Because Area Start ##### -->

        <section class="about-us-area my-5" data-aos="fade-up" data-aos-offset="200" data-aos-delay="10"
            data-aos-duration="1000" data-aos-anchor-placement="top-bottom">
            <div class="container-fluid px-0">
                <h1 class="lemon w-100 text-center pt-1"
                    style="z-index: 1; position: absolute; transform: rotate(-10deg); margin-left: -30px;">
                    Malahini<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Because...</h1>
                <div class="row">
                    <div class="col-12 col-md-6"
                        :style="'background-image: url(' + require('@/assets/images2/malahini-because.jpg') + '); background-position: bottom; background-size: cover; height: 50vh;'">

                    </div>
                    <div class="col-12 col-md-6 align-content-center">

                        <p class="d-block d-sm-none mt-3"></p>
                        <div class="container d-flex h-100 pt-xs-5">
                            <div class="justify-content-center align-self-center mx-auto">
                                <h6 class="font-weight-bold wow fadeInUp mb-4" data-wow-delay="900ms">An affordable 5* boutique resort in the Indian Ocean</h6>
                                
                                <h6 class="font-weight-bold wow fadeInUp" data-wow-delay="300ms">Only 10 minutes from
                                    the airport</h6>

                                <p class="text-muted wow fadeInUp" data-wow-delay="400ms">Means you got more time to
                                    explore and more time to enjoy our happy vibes</p>
                                <h6 class="font-weight-bold wow fadeInUp" data-wow-delay="500ms">Life is better at the
                                    beach</h6>

                                <p class="text-muted wow fadeInUp" data-wow-delay="600ms">Take pleasure in the little
                                    things</p>
                                <h6 class="font-weight-bold wow fadeInUp" data-wow-delay="700ms">Adventure beckons</h6>

                                <p class="text-muted wow fadeInUp" data-wow-delay="800ms">Let us share our moments with
                                    you</p>
                                <h6 class="font-weight-bold wow fadeInUp" data-wow-delay="900ms">Good vibes all day,
                                    everyday!</h6>

                                <p class="text-muted wow fadeInUp" data-wow-delay="1000ms">Make Malahini your happy
                                    place this year</p>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
        <!-- ##### Malahini Because Area End ##### -->
        <!-- ##### Rooms Area Start ##### -->
        <section class="rooms-area my-5" data-aos="fade-up" data-aos-offset="200" data-aos-delay="10"
            data-aos-duration="1000" data-aos-anchor-placement="top-bottom">
            <div class="container-fluid px-0">
                <div class="row">
                    <!-- Single Rooms Area -->
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="single-rooms-area mb-0 wow fadeInUp" data-wow-delay="500ms">
                            <!-- Thumbnail -->
                            <div class="bg-thumbnail bg-img"
                                style="background-image: url(https://www.malahini.mv:9443/web/api/picture/201);"></div>
                            <div class="p-2 home-room-text">
                                <div class="row">
                                    <div class="col-8">
                                        <h3 class="mb-0 lemon" style="color: white;">Sunset Beach Pool Suite</h3>
                                    </div>
                                    <div class="col-4 pt-1">
                                        <!-- <p></p> -->
                                        <a href="#/page/rooms/tile0" class="home-room-details float-right">
                                            <span>

                                                &nbsp;&nbsp;Details&nbsp;&nbsp;
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Single Rooms Area -->
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="single-rooms-area mb-0 wow fadeInUp" data-wow-delay="500ms">
                            <!-- Thumbnail -->
                            <div class="bg-thumbnail bg-img"
                                style="background-image: url(https://www.malahini.mv:9443/web/api/picture/204);"></div>
                            <div class="p-2 home-room-text">
                                <div class="row">
                                    <div class="col-8">
                                        <h3 class="mb-0 lemon" style="color: white;">Sunrise Beach Pool Villa</h3>
                                    </div>
                                    <div class="col-4 pt-1">
                                        <!-- <p></p> -->
                                        <a href="#/page/rooms/tile1" class="home-room-details float-right">
                                            <span>

                                                &nbsp;&nbsp;Details&nbsp;&nbsp;
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Single Rooms Area -->
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="single-rooms-area mb-0 wow fadeInUp" data-wow-delay="500ms">
                            <!-- Thumbnail -->
                            <div class="bg-thumbnail bg-img"
                                style="background-image: url(https://www.malahini.mv:9443/web/api/picture/178);"></div>
                            <div class="p-2 home-room-text">
                                <div class="row">
                                    <div class="col-8">
                                        <h3 class="mb-0 lemon" style="color: white;">Deluxe Room</h3>
                                    </div>
                                    <div class="col-4 pt-1">
                                        <!-- <p></p> -->
                                        <a href="#/page/rooms/tile2" class="home-room-details float-right">
                                            <span>

                                                &nbsp;&nbsp;Details&nbsp;&nbsp;
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="rooms-area my-5" data-aos="fade-up" data-aos-offset="200" data-aos-delay="10"
            data-aos-duration="1000" data-aos-anchor-placement="top-bottom">
            <div class="container-fluid px-0">
                <div class="row">
                    <!-- Single Rooms Area -->
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="single-rooms-area mb-0 wow fadeInUp" data-wow-delay="500ms">
                            <!-- Thumbnail -->
                            <div class="bg-thumbnail bg-img"
                                style="background-image: url(https://www.malahini.mv:9443/web/api/picture/62);"></div>
                            <div class="p-2 home-room-text">
                                <div class="row">
                                    <div class="col-8">
                                        <h3 class="mb-0 lemon" style="color: white;">Superior Room</h3>
                                    </div>
                                    <div class="col-4 pt-1">
                                        <!-- <p></p> -->
                                        <a href="#/page/rooms/tile3" class="home-room-details float-right">
                                            <span>

                                                &nbsp;&nbsp;Details&nbsp;&nbsp;
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Single Rooms Area -->
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="single-rooms-area mb-0 wow fadeInUp" data-wow-delay="300ms">
                            <!-- Thumbnail -->
                            <div class="bg-thumbnail bg-img"
                                style="background-image: url(https://www.malahini.mv:9443/web/api/picture/73);"></div>
                            <div class="p-2 home-room-text">
                                <div class="row">
                                    <div class="col-8">
                                        <h3 class="mb-0 lemon" style="color: white;">Garden Room</h3>
                                    </div>
                                    <div class="col-4 pt-1">
                                        <!-- <p></p> -->
                                        <a href="#/page/rooms/tile4" class="home-room-details float-right">
                                            <span>

                                                &nbsp;&nbsp;Details&nbsp;&nbsp;
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- ##### Rooms Area End ##### -->

        <!-- ##### Virtual Area Start ##### -->

        <section class="about-us-area my-5" data-aos="fade-up" data-aos-offset="200" data-aos-delay="10"
            data-aos-duration="1000" data-aos-anchor-placement="top-bottom">
            <div class="virtual-div">
                <div class="embed-responsive embed-responsive-21by9">
                    <iframe class="embed-responsive-item"
                        src="https://geckodigital.co/vt/MalahiniKudaBandos/?ss=scene_Aerial_Overview" width="100%"
                        height="600px" frameborder="0"></iframe>
                </div>

            </div>
        </section>
        <!-- ##### Virtual Area End ##### -->
        <!-- ##### Reviews Area Start ##### -->
        <div class="container mt-5">
            <div class="col-12">
                <div class="col-12 " data-aos="fade-up" data-aos-offset="200" data-aos-delay="10"
                    data-aos-duration="1000" data-aos-anchor-placement="top-bottom">
                    <div class="my-5 section-heading">
                        <!-- <div class="line-"></div> -->
                        <h2 class="text-center">Reviews</h2>
                        <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec malesuada lorem maximus mauris sceleri sque, at rutrum nulla dictum. Ut ac ligula sapien. Suspendisse cursus faucibus finibus. Lorem ipsum dolor sit amet, consectetur adipiscing.</p> -->
                    </div>
                    <div id="reviewCarousel" class="reviews carousel slide" data-ride="carousel" style=" width: 100%;">
                        <!-- Carousel indicators -->
                        <ol class="carousel-indicators">
                            <li data-target="#reviewCarousel" data-slide-to="0" class="active"></li>
                            <li data-target="#reviewCarousel" data-slide-to="1"></li>
                            <li data-target="#reviewCarousel" data-slide-to="2"></li>
                        </ol>
                        <!-- Wrapper for carousel items -->
                        <div class="reviews carousel-inner">
                            <div v-for="(review, index) in reviewList" class="item carousel-item"
                                :class="{'active' : index == 0}" :key="index">
                                <!-- <div class="img-box"><img  class="review-img img-fluid" :src="review.ReviewSource == 'Trip Advisor' ? require('@/assets/img/core-img/trip.png') : review.ReviewSource == 'Booking.com' ? require('@/assets/img/core-img/booking.png') : review.ReviewSource == 'Expedia' ? require('@/assets/img/core-img/expedia.png') : review.ReviewSource == 'Google' ? require('@/assets/img/core-img/google.png') : review.ReviewSource == 'Holiday Check' ? require('@/assets/img/core-img/holidaycheck.png') : review.ReviewSource == 'Facebook' ? require('@/assets/img/core-img/facebook.png') : require('@/assets/img/core-img/agoda.png')" alt=""></div> -->
                                <h4 class="text-center">{{review.ReviewerName}}</h4>
                                <p class="testimonial">{{review.ReviewDetail}}</p>
                                <p class="overview"><a href="">{{review.ReviewDate}}</a> <br> <img
                                        class="review-img img-fluid mt-3"
                                        :src="review.ReviewSource == 'Trip Advisor' ? require('@/assets/img/core-img/trip.png') : review.ReviewSource == 'Booking.com' ? require('@/assets/img/core-img/booking.png') : review.ReviewSource == 'Expedia' ? require('@/assets/img/core-img/expedia.png') : review.ReviewSource == 'Google' ? require('@/assets/img/core-img/google.png') : review.ReviewSource == 'Holiday Check' ? require('@/assets/img/core-img/holidaycheck.png') : review.ReviewSource == 'Facebook' ? require('@/assets/img/core-img/facebook.png') : require('@/assets/img/core-img/agoda.png')"
                                        alt="" style="width: 50px"></p>
                                <!-- <div class="star-rating">
                            <ul class="list-inline">
                                <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                <li class="list-inline-item"><i class="fa fa-star"></i></li>
                                <li class="list-inline-item"><i class="fa fa-star-o"></i></li>
                            </ul>
                        </div> -->
                            </div>
                        </div>
                        <!-- Carousel controls -->
                        <a class="reviews carousel-control left carousel-control-prev" href="#reviewCarousel"
                            data-slide="prev">
                            <i class="fa fa-angle-left"></i>
                        </a>
                        <a class="reviews carousel-control right carousel-control-next" href="#reviewCarousel"
                            data-slide="next">
                            <i class="fa fa-angle-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!-- ##### Reviews Area End ##### -->

        <div data-aos="fade-up" data-aos-offset="200" data-aos-delay="10" data-aos-duration="1000"
            data-aos-anchor-placement="top-bottom">

            <!-- ##### Contact Area Start ##### -->
            <section class="contact-area d-flex flex-wrap align-items-center my-5">
                <div class="home-map-area">
                    <iframe
                        src="https://maps.google.com/maps?q=Malahini%20Kuda%20Bandos&t=k&z=17&ie=UTF8&iwloc=&output=embed"
                        allowfullscreen></iframe>
                    <!-- <div class="mapouter"><div class="gmap_canvas"><iframe width="600" height="500" id="gmap_canvas" src="https://maps.google.com/maps?q=Malahini%20Kuda%20Bandos&t=k&z=17&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe><a href="https://www.embedgooglemap.net">embedgooglemap.net</a></div><style>.mapouter{position:relative;text-align:right;height:500px;width:600px;}.gmap_canvas {overflow:hidden;background:none!important;height:500px;width:600px;}</style></div> -->
                </div>
                <!-- Contact Info -->
                <div class="contact-info">
                    <div class="section-heading wow fadeInUp" data-wow-delay="100ms">
                        <div class="line-"></div>
                        <h2>Contact Info</h2>
                        <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec malesuada lorem maximus mauris sceleri sque, at rutrum nulla dictum. Ut ac ligula sapien. Suspendisse cursus faucibus finibus. Lorem ipsum dolor sit amet, consectetur adipiscing.</p> -->
                    </div>
                    <h4 class="wow fadeInUp" data-wow-delay="300ms">Malahini Kuda Bandos, North Male' Atoll , Republic
                        of Maldives</h4>
                    <h5 class="wow fadeInUp" data-wow-delay="400ms"> +960 664 4556</h5>
                    <h5 class="wow fadeInUp" data-wow-delay="500ms">reservations@malahini.mv</h5>

                    <!-- Social Info -->
                    <div class="social-info wow fadeInUp mt-5 mb-2" data-wow-delay="600ms">
                        <!-- <a href="#"><i class="fa fa-pinterest"></i></a> -->
                        <a href="https://www.facebook.com/kudabandos/"><i
                                class="fab fa-2x fa-facebook-f"></i></a>&nbsp;&nbsp;&nbsp;
                        <a href="https://twitter.com/malahiniresort"><i class="fab fa-2x fa-twitter"
                                aria-hidden="true"></i></a>&nbsp;&nbsp;&nbsp;
                        <a href="https://www.instagram.com/malahinikb/"><i class="fab fa-2x fa-instagram"></i></a>
                        <!-- <a href="#"><i class="fa fa-behance" aria-hidden="true"></i></a> -->
                        <!-- <a href="#"><i class="fa fa-linkedin" aria-hidden="true"></i></a> -->
                    </div>
                </div>
            </section>
            <!-- ##### Contact Area End ##### -->
        </div>

    </div>
</template>
<script>
import {_} from 'vue-underscore';
import moment from 'moment';
export default {
    name: 'Home',
    data: ()=>({
        caroInterval: 0,
        homeSlide: 0,
        reviewList: [],
        hovered: false
    }),
    metaInfo: {
        title: 'Malahini Kuda Bandos',
        meta: [
        { charset: 'utf-8' },
            { name: "description", content: "five star, 5 star,Malahini Kuda Bandos,Good for solo traveller,Beautiful beach,maldives,Resorts,close to Airport,Boutique,Honeymoon resort,Beach villa,Eco hotel maldives,environment friendly Hotel,male Atoll,Speed boat transfer,local hotel,Budget resort,Weddings in maldives,Small island Environment friendly hotel,male Atoll,speedboat transfer,local hotel,budget resort,Weddings in maldives,Small island,Crystal clear water,white beach,beautiful beach,Vacation maldives,Holiday maldives,free wifi,green resort,Excellent food,Affordable five star resort,5 star resort" },
            { name: "keywords", content: "five star, 5 star, Malahini Kuda Bandos,Good for solo traveller,Beautiful beach,maldives,Resorts,close to Airport,Boutique,Honeymoon resort,Beach villa,Eco hotel maldives,environment friendly Hotel,male Atoll,Speed boat transfer,local hotel,Budget resort,Weddings in maldives,Small island Environment friendly hotel,male Atoll,speedboat transfer,local hotel,budget resort,Weddings in maldives,Small island,Crystal clear water,white beach,beautiful beach,Vacation maldives,Holiday maldives,free wifi,green resort,Excellent food,Affordable five star resort,5 star resort" }
        ]
    },
    mounted() {
        this.$http.get('https://www.malahini.mv:9443/web/api/review').then((response)=>{
            let reviews = _.where(response.data, {ShowOnReviews: true}); // Get the sorted results
            this.reviewList = reviews.reverse()
            this.reviewList = this.reviewList
            for (let r of this.reviewList) {
                r.ReviewDate = moment(r.ReviewDate).format('DD MMMM YYYY')
            }
        })
        this.$refs.myCarousel.pause()
    },
    watch: {
        homeSlide: function(val) {
        if (val == '0') {
            this.$refs.myCarousel.pause()
            this.$refs.video.pause();
            this.$refs.video.currentTime = 0;
            this.$refs.video.load();
        } else {
            this.caroInterval = 4000
        }
        }
    },
    methods: {
        myHandler(e) {
            if (this.$refs.myCarousel) {
            this.$refs.myCarousel.start()
            this.$refs.myCarousel.next()

            }
        },
        showDrop (index) {
        }
    }
}
</script>


<style>

.col-center {
	margin: 0 auto;
	float: none !important;
}
.reviews.carousel {
	width: 650px;
	margin: 0 auto;
	padding-bottom: 50px;
}
.reviews.carousel .item {
	color: #999;
	font-size: 14px;
    text-align: center;
	overflow: hidden;
    min-height: 340px;
}
.reviews.carousel .item a {
	color: #eb7245;
}
.reviews.carousel .img-box {
	width: 145px;
	height: 145px;
	margin: 0 auto;
	border-radius: 50%;
}
.reviews.carousel .img-box img {
    width: 80px;
    height: 80px !important;
	/* height: auto !important; */
	display: block;
	/* border-radius: 50%; */
}
.reviews.carousel .testimonial {	
	padding: 30px 0 10px;
}
.reviews.carousel .overview {	
	text-align: center;
	padding-bottom: 5px;
}
.reviews.carousel .overview b {
	color: #333;
	font-size: 15px;
	text-transform: uppercase;
	display: block;	
	padding-bottom: 5px;
}
.reviews.carousel .star-rating i {
	font-size: 18px;
	color: #ffdc12;
}
.reviews.carousel .carousel-control {
	width: 30px;
	height: 30px;
	border-radius: 50%;
    background: #999;
    text-shadow: none;
	top: 4px;
}
.reviews.carousel-control i {
	font-size: 20px;
	margin-right: 2px;
}
.reviews.carousel-control.left {
	left: auto;
	right: 40px;
}
.reviews.carousel-control.right i {
	margin-right: -2px;
}
.reviews.carousel .carousel-indicators {
	bottom: 15px;
}
.reviews.carousel-indicators li, .reviews.carousel-indicators li.active {
	width: 11px;
	height: 11px;
	margin: 1px 5px;
	border-radius: 50%;
}
.reviews.carousel-indicators li {	
	background: #e2e2e2;
	border-color: transparent;
}
.reviews.carousel-indicators li.active {
	border: none;
	background: #888;		
}
.review-img  {
}
.row {
    margin:0 !important;
}
.carousel-caption {
    position: absolute;
    /* right: 15%; */
    bottom: 30% !important;
    left: 5%  !important;
    z-index: 100;
    /* padding-top: 20px; */
    /* padding-bottom: 20px; */
    color: #fff;
    text-align: center;
    display: inline-block;
    padding: 30px 30px  !important;
    background-color: rgba(0, 0, 0, 0.40);
    /* border: 2px solid #5da9ae; */
    text-align: center;
    width: 300px;
}
.carousel-caption p {
    font-size: 20px !important;
    line-height: 1.3;
    font-weight: 400;
    color: white;
}
</style>